import { http } from '../rest';

export function fetch(http, demo) {
  return {
    async execute() {
      let data;
      if (demo) {
        const file = await import('./fetch_fee_report.data');
        data = file.default();
      } else {
        const response = await http.get('/payments_csv');
        data = response.data;
      }
      return data.csv;
    },
  };
}

export default fetch(http, process.env.DEMO);
